"use client";

import React, { type ReactNode } from "react";
import styles from "./styles.module.css";

interface ContactsBannerProps {
	children: ReactNode;
	className?: string;
}

export default function ContactsBanner({
	children,
	className = "",
}: ContactsBannerProps) {
	return (
		<section
			className={`${styles.contactsbanner} ${className}`}
			aria-labelledby="contacts-title"
		>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<h2 id="contacts-title" className={styles.title}>
						Возникли вопросы? <br />
						Мы поможем и подскажем
					</h2>
					<p className={styles.description}>
						Вы можете задать любой вопрос на тему работы портала. Мы постараемся
						ответить на него как можно быстрее и подробнее
					</p>
				</div>

				<div className={styles.formWrapper}>{children}</div>
			</div>
		</section>
	);
}
